<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        :placeholder="$t('table.imei')"
        v-model="listQuery.identity"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter" />
      <el-date-picker
        v-model="listQuery.startTime"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetime"
        class="filter-item"
        placeholder="选择开始日期" />
      <el-date-picker
        v-model="listQuery.endTime"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetime"
        class="filter-item"
        placeholder="选择结束日期" />
      <el-button
        v-waves
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter">{{ $t('table.search') }}</el-button>
    </div>
    <div class="filter-container">
      <el-table
        v-loading="listLoading"
        :key="tableKey"
        :data="list"
        border
        fit
        stripe
        highlight-current-row
        style="width: 100%;">
        <el-table-column
          type="index"
          width="100"
          align="center" />
        <el-table-column
          :label="$t('table.imei')"
          prop="Identity"
          sortable
          align="center"
          width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.Identity">{{ scope.row.Identity }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="金额/元"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.Price">{{ scope.row.Price }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手续费/元"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.Poundage">{{ scope.row.Poundage }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="实际到账/元"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.Cost">{{ scope.row.Cost }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单单号"
          min-width="100%"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.OrderNum">{{ scope.row.OrderNum }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="转账时间"
          width="300px"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AddTime">{{ scope.row.AddTime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          v-show="total>0"
          :current-page="listQuery.pageIndex"
          :page-sizes="[10,20,50,100]"
          :page-size="listQuery.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { TransferList } from '@/api/account'
import waves from '@/directive/waves' // 水波纹指令
import { parseTime } from '@/utils'

export default {
  name: 'TransferAccount',
  directives: {
    waves
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        identity: '',
        startTime: '',
        endTime: '',
        userId: this.$store.getters.roles.UserId
      }
    }
  },
  computed: {
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(function() {

    })
  },
  methods: {
    getList() {
      this.listLoading = true
      TransferList(this.listQuery).then(response => {
        this.list = response.LsList
        this.total = response.TotalRows
        this.resetTemp()
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        identity: '',
        startTime: '',
        endTime: '',
        userId: this.$store.getters.roles.UserId
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>
